import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetalleEspacioPorCerealLinea5Actions'
import { TablaDetalleEspacioPorCerealLinea5View } from '../components/TablaDetalleEspacioPorCerealLinea5View'

class TablaDetalleEspacioPorCerealLinea5 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetalleEspacioPorCerealLinea5View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetalleEspacioPorCerealLinea5)
